import { render } from "./InfoTicketComponent.vue?vue&type=template&id=a07fa052"
import script from "./InfoTicketComponent.vue?vue&type=script&lang=js"
export * from "./InfoTicketComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__